export class Facility {
    id: number;
    name: string;
    acronym: string;
    modifiedByUserName: string;
    modifiedDate: Date;
    payPeriodStartDate: Date;
    timeZoneId: string
}